import clsx from 'clsx';
import React from 'react';

const CheckoutWrapper = ({ children, className, checkoutType }) => {
  return (
    <div
      className={clsx('cp_checkout mx-auto w-full', className, {
        'max-w-screen-xs': checkoutType !== 'embed',
      })}
    >
      {children}
    </div>
  );
};

export default CheckoutWrapper;
